// Small CSV helpers shared by the admin exports. Excel-friendly: UTF-8 BOM (so æøå render)
// and CRLF line endings.

function csvCell(v) {
    const s = String(v ?? "");
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

// buildCsv turns a header array + array-of-arrays rows into a CSV string.
export function buildCsv(header, rows) {
    const lines = rows.map(r => r.map(csvCell).join(","));
    return "﻿" + [header.map(csvCell).join(","), ...lines].join("\r\n");
}

// locSlug makes a filename-safe slug from a display name, e.g. "Porten Vridsløse" -> "Porten-Vridsløse".
export function locSlug(name) {
    return String(name || "").trim().replace(/[\s/\\]+/g, "-");
}

// downloadCsv triggers a browser download of the given CSV string.
export function downloadCsv(filename, csv) {
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
